import React from "react";

import {
	SCORING_COMPLETE_TASK,
	SCORING_PARTIAL_TASK,
	SCORING_FAILED_TASK,
	SCORING_FAILED_FALLBACK_MESSAGE,
	isPredictiveScoringTask,
	isPartialScoringTask,
	isFailedScoringTask
} from "./predictiveScoringTask";

export function shouldRenderPredictiveScoring({ origin, task }) {
	if (!/jcrm/i.test(origin)) {
		return false;
	}
	return isPredictiveScoringTask(task);
}

export default function PredictiveScoringNotification(props) {
	const { task, data: rawData, clearMessage, iconInfo, prettyTime, timestamp } = props;
	const data = rawData || {};
	const isPartial = isPartialScoringTask(task);
	const isFailed = isFailedScoringTask(task);
	const failedCount = data.failedEntityIds?.length || 0;

	let title;
	let body;
	if (isFailed) {
		title = SCORING_FAILED_TASK;
		body = data.failureReason || SCORING_FAILED_FALLBACK_MESSAGE;
	} else if (isPartial) {
		title = SCORING_PARTIAL_TASK;
		body = `Scoring completed with ${failedCount} failure(s).`;
	} else {
		title = SCORING_COMPLETE_TASK;
		body = "Your creative scores are ready.";
	}

	return [
		<i key="status-icon" className={`ft-ic status-icon ${iconInfo?.icon}`} title={iconInfo?.title} />
		, <div key="body" className="message-body">
			<strong>{title}</strong>
			<p>{body}</p>
		</div>
		, <i key="clear" className="ft-ic fal fa-times clear-message" title="Clear Message" onClick={clearMessage} />
		, <b key="empty" />
		, <span key="footer" className="message-footer" />
		, <time key="time" className="message-time" dateTime={timestamp}>{prettyTime}</time>
	];
}
